export const VDA_FUNNEL_STATES = {
  ON_RAMP_INITIATED: 'ON_RAMP_INITIATED',
  ON_RAMP_PROCESSING: 'ON_RAMP_PROCESSING',
  ON_RAMP_COMPLETED: 'ON_RAMP_COMPLETED',
  OFF_RAMP_INITIATED: 'OFF_RAMP_INITIATED',
  OFF_RAMP_COMPLETED: 'OFF_RAMP_COMPLETED'
};
